import { onUnmounted } from '@vue/composition-api'

export function usePlaneSocket(onUpdate, onAlarmEvent, onPanelUpdate) {
  const channelNames = new Set()

  const handleEvent = (event, plane) => {
    console.log(`Evento recibido en plano ${plane.id}:`, event)

    if (event.event_type === 'dispatched_alarm' || event.event_type === 'canceled_alarm') {
      if (onAlarmEvent) onAlarmEvent(event)
      return
    }

    if (event.event_type === 'dmp_panel_update' || event.event_type === 'dmp_panel_device_alarm') {
      console.log('Panel DMP update recibido:', event)
      if (onPanelUpdate) onPanelUpdate(event)
      return
    }

    if (onUpdate) onUpdate(event, plane)
  }

  const connect = (planes) => {
    disconnect()
    if (!planes?.length) return

    if (!window.Echo) {
      console.warn('Echo no está disponible — WebSocket no conectado')
      return
    }

    try {
      planes.forEach((plane) => {
        const channelName = `floor-plant-events-${plane.id}`
        channelNames.add(channelName)
        console.log('Conectando canal:', channelName)

        window.Echo.private(channelName).listen('.device.updated', (event) => {
          handleEvent(event, plane)
        })
      })
    } catch (err) {
      console.error('Error al conectar canal WebSocket:', err)
      disconnect()
    }
  }

  const disconnect = () => {
    if (!window.Echo) {
      channelNames.clear()
      return
    }

    channelNames.forEach((channelName) => {
      console.log('Desconectando canal:', channelName)
      window.Echo.leave(channelName)
    })
    channelNames.clear()
  }

  onUnmounted(() => {
    disconnect()
  })

  return { connect, disconnect }
}
